<template>
    <b-modal
        id="add-slide-modal"
        v-model="modal"
        :ok-title="$t('common.add')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        :title="$t('presentation.edit.add_slide')"
        @ok="ok"
        modal-class="apprentice-default-modal">
        <div class="slide-options">
            <div
                class="slide slide-image-text"
                :class="{ selected: type === 1 }"
                @click="onClickText()">
                <i class="fad fa-file-alt fa-fw icon"></i>
                <p class="description">{{ $t('presentation.slide_with_text_and_images') }}</p>
            </div>

            <div
                class="slide slide-video"
                :class="{ selected: type === 2 }"
                @click="onClickVideo()">
                <i class="fad fa-file-video fa-fw icon"></i>
                <p class="description">{{ $t('presentation.slide_for_entering_youtube_link') }}</p>
            </div>

            <div
                class="slide slide-input-field-title-less"
                :class="{ selected: type === 3 }"
                @click="onClickList()">
                <i class="fad fa-bars fa-fw icon"></i>
                <p class="description">{{ $t('presentation.slide_with_input_fields_without_title') }}</p>
            </div>

            <div
                class="slide slide input-field"
                :class="{ selected: type === 4 }"
                @click="onClickNamedList()">
                <i class="fad fa-list fa-fw icon"></i>
                <p class="description">{{ $t('presentation.slide_for_input_fields_with_title') }}</p>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-presentation-add-slide-modal',
    props: {
        presentationIn: {
            required: true,
            type: Object,
        },
    },
    data() {
        return {
            type: null,
            hasError: false,
            errorMessage: '',
            modal: false,
            step_id: null,
        };
    },
    methods: {
        show(stepId) {
            this.step_id = stepId;
            this.hasError = false;
            this.modal = true;
        },

        ok() {
            let data = {
                step_id: this.step_id,
                type: this.type,
            };

            this.alert.saving();
            this.axios.post(this.routes.presentationSlide(), data).then(
                (response) => {
                    this.$emit('presentation-updated', response.data);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        onClickText() {
            this.type = this.type === 1 ? null : 1;
        },
        onClickVideo() {
            this.type = this.type === 2 ? null : 2;
        },
        onClickList() {
            this.type = this.type === 3 ? null : 3;
        },
        onClickNamedList() {
            this.type = this.type === 4 ? null : 4;
        },
    },
};
</script>

<style scoped lang="scss">
.slide-options {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: $grid-gutter-width;

    .slide {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-direction: column;
        gap: map-get($grid-gutter-spacing, 'fifteen');
        background-color: $secondary-background-color;
        flex: 1 0 calc(50% - 15px);
        padding: map-get($grid-gutter-spacing, 'fifteen');
        border-radius: $border-radius-content;
        border: 1px solid transparent;
        align-self: stretch;

        .icon {
            font-size: 3.3125rem;
            align-self: center;
            color: $primary;
        }

        .description {
            margin-bottom: 0;
            color: $text-muted-color;
        }

        &:hover {
            cursor: pointer;
            box-shadow: 3px 0 7px rgba($primary-darken-alternative, 23%);

            .icon {
                color: $primary-darken-alternative;
            }
        }

        &.selected {
            border: 1px solid $primary-darken-alternative;

            .icon {
                color: $primary-darken-alternative;
            }
        }
    }
}
</style>
